import * as types from '../constants/newsFeedConstants';

export function loadNewsFeedComponent() {
  return {
    type: types.LOAD_NEWSFEED,
    promise: (client) => client.post('/getNewsFeedData', {
       data: {
         PT:"F"
       }
    })
  };
}
